import { BookOpen, Headset } from "lucide-react";
import { Layout } from "../layout/Layout";
import { SidebarManagment } from "../components/admin-views/gerencia/sidebarmanagment";
import gerenteManualPdf from "../assets/manuals/Manual_de_usuario-Gerente.pdf";
import soporteManualPdf from "../assets/manuals/Manual_de_usuario-Soporte.pdf";

const manuals = [
	{
		role: "Gerente",
		description: "Guía completa para la gestión de la plataforma: usuarios, pedidos, cupones y configuración del sistema.",
		href: gerenteManualPdf,
		Icon: BookOpen,
		accent: "bg-primary",
		labelColor: "text-primary",
		badgeBg: "bg-secondary",
	},
	{
		role: "Soporte",
		description: "Guía operativa para el equipo de soporte: atención de pedidos, arbitraje y gestión de proveedores.",
		href: soporteManualPdf,
		Icon: Headset,
		accent: "bg-slate-700",
		labelColor: "text-slate-700",
		badgeBg: "bg-slate-100",
	},
];

export function ManualManager() {
	return (
		<Layout>
			<div className="flex min-h-[calc(100vh-160px)]">
				<SidebarManagment />

				<main className="flex-1 bg-gray-50">
					<div className="mx-auto max-w-3xl px-6 py-12">
						<div className="mb-10">
							<p className="text-xs font-medium uppercase tracking-widest text-primary">Documentación</p>
							<h1 className="mt-1 text-2xl font-semibold text-slate-900">Manuales de usuario</h1>
							<p className="mt-2 text-sm text-slate-500">
								Selecciona el manual correspondiente a tu rol dentro de la plataforma.
							</p>
						</div>

						<div className="grid gap-5 sm:grid-cols-2">
							{manuals.map(({ role, description, href, Icon, accent, labelColor, badgeBg }) => (
								<a
									key={role}
									href={href}
									target="_blank"
									rel="noopener noreferrer"
									className="group flex flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
								>
									<div className={`mb-5 flex h-11 w-11 items-center justify-center rounded-xl ${badgeBg}`}>
										<Icon className={`h-5 w-5 ${labelColor}`} strokeWidth={1.75} />
									</div>

									<p className={`text-xs font-semibold uppercase tracking-wider ${labelColor}`}>
										{role}
									</p>
									<h2 className="mt-1 text-base font-semibold text-slate-900">
										Manual de {role}
									</h2>
									<p className="mt-2 flex-1 text-sm leading-relaxed text-slate-500">
										{description}
									</p>

									<div className="mt-6">
										<span
											className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-xs font-medium text-white transition-opacity group-hover:opacity-90 ${accent}`}
										>
											Ver manual
											<svg
												xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 20 20"
												fill="currentColor"
												className="h-3.5 w-3.5"
											>
												<path
													fillRule="evenodd"
													d="M5.22 14.78a.75.75 0 0 1 0-1.06L9.44 9.5 5.22 5.28a.75.75 0 0 1 1.06-1.06l4.75 4.75a.75.75 0 0 1 0 1.06l-4.75 4.75a.75.75 0 0 1-1.06 0Z"
													clipRule="evenodd"
												/>
											</svg>
										</span>
									</div>
								</a>
							))}
						</div>
					</div>
				</main>
			</div>
		</Layout>
	);
}
